// import React, { useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Configuration from "../../config/configuration";

// const RedirectToPDF = () => {
//     const location = useLocation();

//     const brochures = {
//         UHFBrochure: `${Configuration.S3_URL}brochure/UHFRadioModem.pdf`,
//         IN_OFES_V2Brochure: `${Configuration.S3_URL}brochure/IN_OFES_V2.pdf`,
//         IN_SRFX_20DBrochure: `${Configuration.S3_URL}brochure/IN_SRFX_20D.pdf`,
//         EmbeddedPCBrochure: `${Configuration.S3_URL}brochure/EmbeddedPC.pdf`,
//         FireandSafetyBrochure: `${Configuration.S3_URL}brochure/FireandSafety.pdf`,
//         CoachesHealthMonitoringSystemBrochure: `${Configuration.S3_URL}brochure/CoachesHealthMonitoringSystem.pdf`,
//         MultiProductWebAppBrochure: `${Configuration.S3_URL}brochure/MultiProductWebApp.pdf`,
//         KavachHealthMonitoringBrochure: `${Configuration.S3_URL}brochure/KavachHealthMonitoring.pdf`,
//         CentralhealthMonitoringSystemBrochure: `${Configuration.S3_URL}brochure/CentralhealthMonitoringSystem.pdf`,
//         IOTBrochure: `${Configuration.S3_URL}brochure/IOT.pdf`,
//         V3000Brochure: `${Configuration.S3_URL}brochure/V3000.pdf`,
//         Bothv3000andv8000withsensiconnectBrochure: `${Configuration.S3_URL}brochure/v3000_and_v8000_with_sensiconnect.pdf`,
//         R8000Brochure: `${Configuration.S3_URL}brochure/R8000.pdf`,
//     };

//     useEffect(() => {
//         const pathMapping = {
//             "/UHFBrochure": brochures.UHFBrochure,
//             "/IN_OFES_V2Brochure": brochures.IN_OFES_V2Brochure,
//             "/IN_SRFX_20DBrochure": brochures.IN_SRFX_20DBrochure,
//             "/EmbeddedPCBrochure": brochures.EmbeddedPCBrochure,
//             "/FireandSafetyBrochure": brochures.FireandSafetyBrochure,
//             "/CoachesHealthMonitoringSystemBrochure": brochures.CoachesHealthMonitoringSystemBrochure,
//             "/MultiProductWebAppBrochure": brochures.MultiProductWebAppBrochure,
//             "/KavachHealthMonitoringBrochure": brochures.KavachHealthMonitoringBrochure,
//             "/CentralhealthMonitoringSystemBrochure": brochures.CentralhealthMonitoringSystemBrochure,
//             "/IOTBrochure": brochures.IOTBrochure,
//             "/V3000Brochure": brochures.V3000Brochure,
//             "/Bothv3000andv8000withsensiconnectBrochure": brochures.Bothv3000andv8000withsensiconnectBrochure,
//             "/R8000Brochure": brochures.R8000Brochure,
//         };

//         const pdfPath = pathMapping[location.pathname];

//         if (pdfPath) {
//             const link = document.createElement("a");
//             link.href = pdfPath;
//             link.download = pdfPath.split("/").pop();
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             // window.open(pdfPath, "_blank");
//             window.location.replace(pdfPath);
//         }

//     }, [location]);

//     useEffect(() => {
//         const pdfPath = brochures[location.pathname.replace("/", "")];
//         if (pdfPath) {
//             const redirectUrl = `/pdf-redirect.html?url=${encodeURIComponent(pdfPath)}`;
//             window.location.href = redirectUrl;
//         }
//     }, [location]);


//     return <div style={{
//         height: "100vh",
//         width: '100%',
//         backgroundColor: 'var(--secondary-background-color)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         fontFamily: "PRODUCT_DESCRIPTION",
//         color: 'var(--main-heading)'
//     }}>Redirecting to download...</div>;
// };

// export default RedirectToPDF;


// import React, { useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Configuration from "../../config/configuration";

// const brochures = {
//   UHFBrochure: `${Configuration.S3_URL}brochure/UHFRadioModem.pdf`,
//   IN_OFES_V2Brochure: `${Configuration.S3_URL}brochure/IN_OFES_V2.pdf`,
//   IN_SRFX_20DBrochure: `${Configuration.S3_URL}brochure/IN_SRFX_20D.pdf`,
//   EmbeddedPCBrochure: `${Configuration.S3_URL}brochure/EmbeddedPC.pdf`,
//   FireandSafetyBrochure: `${Configuration.S3_URL}brochure/FireandSafety.pdf`,
//   CoachesHealthMonitoringSystemBrochure: `${Configuration.S3_URL}brochure/CoachesHealthMonitoringSystem.pdf`,
//   MultiProductWebAppBrochure: `${Configuration.S3_URL}brochure/MultiProductWebApp.pdf`,
//   KavachHealthMonitoringBrochure: `${Configuration.S3_URL}brochure/KavachHealthMonitoring.pdf`,
//   CentralhealthMonitoringSystemBrochure: `${Configuration.S3_URL}brochure/CentralhealthMonitoringSystem.pdf`,
//   IOTBrochure: `${Configuration.S3_URL}brochure/IOT.pdf`,
//   V3000Brochure: `${Configuration.S3_URL}brochure/V3000.pdf`,
//   Bothv3000andv8000withsensiconnectBrochure: `${Configuration.S3_URL}brochure/v3000_and_v8000_with_sensiconnect.pdf`,
//   R8000Brochure: `${Configuration.S3_URL}brochure/R8000.pdf`,
// };

// const RedirectToPDF = () => {
//   const location = useLocation();

//   useEffect(() => {
//     const pathMapping = {
//       "/UHFBrochure": brochures.UHFBrochure,
//       "/IN_OFES_V2Brochure": brochures.IN_OFES_V2Brochure,
//       "/IN_SRFX_20DBrochure": brochures.IN_SRFX_20DBrochure,
//       "/EmbeddedPCBrochure": brochures.EmbeddedPCBrochure,
//       "/FireandSafetyBrochure": brochures.FireandSafetyBrochure,
//       "/CoachesHealthMonitoringSystemBrochure":
//         brochures.CoachesHealthMonitoringSystemBrochure,
//       "/MultiProductWebAppBrochure": brochures.MultiProductWebAppBrochure,
//       "/KavachHealthMonitoringBrochure":
//         brochures.KavachHealthMonitoringBrochure,
//       "/CentralhealthMonitoringSystemBrochure":
//         brochures.CentralhealthMonitoringSystemBrochure,
//       "/IOTBrochure": brochures.IOTBrochure,
//       "/V3000Brochure": brochures.V3000Brochure,
//       "/Bothv3000andv8000withsensiconnectBrochure":
//         brochures.Bothv3000andv8000withsensiconnectBrochure,
//       "/R8000Brochure": brochures.R8000Brochure,
//     };

//     const pdfPath = pathMapping[location.pathname];
//     if (!pdfPath) return;

//     // Simple direct navigation – best for iOS + QR WebView
//     // window.location.href = pdfPath;
//     window.open(pdfPath, '_blank');
//   }, [location.pathname]);

//   return (
//     <div
//       style={{
//         height: "100vh",
//         width: "100%",
//         backgroundColor: "var(--secondary-background-color)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         fontFamily: "PRODUCT_DESCRIPTION",
//         color: "var(--main-heading)",
//       }}
//     >
//       Redirecting to brochure...
//     </div>
//   );
// };

// export default RedirectToPDF;



import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Configuration from "../../config/configuration";

const brochures = {
    UHFBrochure: `${Configuration.S3_URL}brochure/UHFRadioModem.pdf`,
    IN_OFES_V2Brochure: `${Configuration.S3_URL}brochure/IN_OFES_V2.pdf`,
    IN_SRFX_20DBrochure: `${Configuration.S3_URL}brochure/IN_SRFX_20D.pdf`,
    EmbeddedPCBrochure: `${Configuration.S3_URL}brochure/EmbeddedPC.pdf`,
    FireandSafetyBrochure: `${Configuration.S3_URL}brochure/FireandSafety.pdf`,
    CoachesHealthMonitoringSystemBrochure: `${Configuration.S3_URL}brochure/CoachesHealthMonitoringSystem.pdf`,
    MultiProductWebAppBrochure: `${Configuration.S3_URL}brochure/MultiProductWebApp.pdf`,
    KavachHealthMonitoringBrochure: `${Configuration.S3_URL}brochure/KavachHealthMonitoring.pdf`,
    CentralhealthMonitoringSystemBrochure: `${Configuration.S3_URL}brochure/CentralhealthMonitoringSystem.pdf`,
    IOTBrochure: `${Configuration.S3_URL}brochure/IOT.pdf`,
    V3000Brochure: `${Configuration.S3_URL}brochure/V3000.pdf`,
    // Bothv3000andv8000withsensiconnectBrochure: `${Configuration.S3_URL}brochure/sensiconnect.pdf`,
    Bothv3000andv8000withsensiconnectBrochure: `${Configuration.S3_URL}brochure/v3000_and_v8000_with_sensiconnect.pdf`,
    R8000Brochure: `${Configuration.S3_URL}brochure/R8000.pdf`,
};



const RedirectToPDF = () => {
    const location = useLocation();

    useEffect(() => {
        const pathMapping = {
            "/UHFBrochure": brochures.UHFBrochure,
            "/IN_OFES_V2Brochure": brochures.IN_OFES_V2Brochure,
            "/IN_SRFX_20DBrochure": brochures.IN_SRFX_20DBrochure,
            "/EmbeddedPCBrochure": brochures.EmbeddedPCBrochure,
            "/FireandSafetyBrochure": brochures.FireandSafetyBrochure,
            "/CoachesHealthMonitoringSystemBrochure":
                brochures.CoachesHealthMonitoringSystemBrochure,
            "/MultiProductWebAppBrochure": brochures.MultiProductWebAppBrochure,
            "/KavachHealthMonitoringBrochure":
                brochures.KavachHealthMonitoringBrochure,
            "/CentralhealthMonitoringSystemBrochure":
                brochures.CentralhealthMonitoringSystemBrochure,
            "/IOTBrochure": brochures.IOTBrochure,
            "/V3000Brochure": brochures.V3000Brochure,
            "/Bothv3000andv8000withsensiconnectBrochure":
                brochures.Bothv3000andv8000withsensiconnectBrochure,
            "/R8000Brochure": brochures.R8000Brochure,
        };

        const pdfPath = pathMapping[location.pathname];
        if (!pdfPath) return;

        // Detect iOS
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        // SOLUTION 1: Using anchor tag (most reliable for iOS)
        const openPDF = () => {
            const link = document.createElement('a');
            link.href = pdfPath;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';

            // Append to body (required for iOS)
            document.body.appendChild(link);

            // Trigger click
            link.click();

            // Clean up
            setTimeout(() => {
                document.body.removeChild(link);
            }, 100);
        };

        // Add slight delay to ensure DOM is ready
        const timer = setTimeout(openPDF, 100);

        return () => clearTimeout(timer);
    }, [location.pathname]);

    return (
        <div
            style={{
                height: "100vh",
                width: "100%",
                backgroundColor: "var(--secondary-background-color)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "PRODUCT_DESCRIPTION",
                color: "var(--main-heading)",
            }}
        >
            Redirecting to brochure...
        </div>
    );
};

export default RedirectToPDF;